/**
 * This source code is quoted from rc-slider.
 * homepage: https://github.com/react-component/slider
 */
import React, { forwardRef, memo } from 'react';
import type {HandleProps, FieldidProps} from './iSlider'

const Handle = memo(forwardRef<HTMLDivElement, HandleProps>((props, ref) => {
    const {
        className, vertical, offset, style, disabled, min, max, value, reverse, fieldid, dir: direction, ...restProps
    } = props;

    // Handle 位置样式
    // 水平模式：正常时 left=offset%，反向时 right=offset%
    // 垂直模式：正常时 bottom=offset%，反向时 top=offset%
    const postionStyle = vertical ?
        (reverse ?
            {top: `${offset}%`, bottom: 'auto'} :
            {bottom: `${offset}%`, top: 'auto'}
        ) :
        (reverse ?
            {[direction === 'rtl' ? "left" : "right"]: `${offset}%`, [direction === 'rtl' ? "right" : "left"]: 'auto'} :
            {[direction === 'rtl' ? "right" : "left"]: `${offset}%`, [direction === 'rtl' ? "left" : "right"]: 'auto'}
        );
    const elStyle = {
        ...style,
        ...postionStyle
    };
    let ariaProps = {};
    if (value !== undefined) {
        ariaProps = {
            ...ariaProps,
            'aria-valuemin': min,
            'aria-valuemax': max,
            'aria-valuenow': value,
            'aria-disabled': !!disabled
        };

    }
    const fieldidObj: FieldidProps = {}
    if (fieldid || fieldid === 0) {
        fieldidObj.fieldid = `${fieldid}_slider_handle`
    }
    return (
        <div
            ref={ref}
            role="slider"
            tabIndex={0}
            {...ariaProps}
            {...restProps}
            className={className}
            style={elStyle}
            {...fieldidObj}
        />
    );
}));

Handle.displayName = 'Handle';

// 创建接口以保持类型兼容
interface HandleComponent extends React.ForwardRefExoticComponent<HandleProps & React.RefAttributes<HTMLDivElement>> {
    defaultHandle: (props: HandleProps & {index: number; ref?: any}) => React.ReactElement;
}

// 将 Handle 转换为 HandleComponent 类型
const HandleWithDefault = Handle as unknown as HandleComponent;

// 默认的 handle 生成函数
HandleWithDefault.defaultHandle = ({index, ...restProps}: HandleProps & {index: number; ref?: any}) => {
    const handleProps = {...restProps};
    delete (handleProps as any).dragging;
    // 使用 forwardRef 确保 ref 正确传递
    if ('ref' in restProps) {
        const refCallback = (restProps as any).ref;
        delete (handleProps as any).ref;
        return <Handle {...handleProps} ref={refCallback} key={index}/>;
    }
    return <Handle {...handleProps} key={index}/>;
};

export default HandleWithDefault;

/* Handle.propTypes = {
    className: PropTypes.string,
    vertical: PropTypes.bool,
    offset: PropTypes.number,
    style: PropTypes.object,
    disabled: PropTypes.bool,
    reverse: PropTypes.bool,
    min: PropTypes.number,
    max: PropTypes.number,
    value: PropTypes.number,
}; */
